import { Link } from 'react-router-dom';
import { breadcrumbHome } from '@/mocks/site';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const allItems = [breadcrumbHome, ...items];

  return (
    <nav aria-label="面包屑导航" className="py-3 mb-3 md:mb-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {allItems.map((item, idx) => {
          const isLast = idx === allItems.length - 1;
          return (
            <li key={idx} className="flex items-center">
              {idx > 0 && (
                <span className="mx-1.5 text-foreground-300">
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              )}
              {isLast || !item.path ? (
                <span className="text-foreground-500 font-medium">{item.label}</span>
              ) : (
                <Link
                  to={item.path}
                  className="text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}